module.exports = __webpack_public_path__ + "CoryFreemanDesign.webp?d75d17ecb499765ed695e20fc98d399d";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/CoryFreemanDesign.webp
// module id = 62
// module chunks = 0